module.exports = __webpack_public_path__ + "static/media/thanos-pal-598887-unsplash.1c57345b.png";